const NAMESPACE = "SCHEDULEALIST";
const actionType = type => `${NAMESPACE}_${type}`;

export const scheduleAListConstants = {
	SET_SORTING: actionType("SET_SORTING"),
	SET_PAGING: actionType("SET_PAGING"),
};
